import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { AssetWizardProps } from "./AssetWizard";
const AssetWizard = lazy(() => import("./AssetWizard").then(module => ({ default: module.AssetWizard })));

export function mountAssetWizard(slot: HTMLElement, props: AssetWizardProps) {
  setStudioView("drawer", "asset-wizard", <AssetWizard key={props.sessionId} {...props} />);
}
